import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { Router } from '@angular/router';

// Interface to define the structure of a whitepaper object
interface Whitepaper {
  image: string;
  title: string;
  route: string;
}

@Component({
  selector: 'app-relevant-whitepaper',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './relevant-whitepaper.component.html',
  styleUrl: './relevant-whitepaper.component.scss'
})
export class RelevantWhitepaperComponent implements OnInit {

  // This array holds the 3 random whitepapers that will be displayed
  relevantWhitepapers: Whitepaper[] = [];

  // This is the master list of ALL available whitepapers
  private allWhitepapers: Whitepaper[] = [
    {
     image: '../../../../assets/resources/whitepaper/it-trends/it-trends.webp',
     route:'/kalpita-white-papers/it-trends',
     title:' IT Trends 2025-2030'
    },
    {
     image: '../../../../assets/resources/whitepaper/designpatterns/introToDesignPatterns.png',
     route:'/kalpita-white-papers/intro-design-patterns',
     title:' Introduction to Design Patterns'
    },
    {
     image: '../../../../assets/resources/whitepaper/creationaldesignpattern/CreationalDesignPattern.webp',
     route:'/kalpita-white-papers/creational-design-patterns',
     title:'Creational Design Pattern'
    },
    {
    image: '../../../../assets/resources/whitepaper/structuraldesignpattern/StructuralDesignPattern.webp',
     route:'/kalpita-white-papers/structural-design-patterns',
     title:' Structural Design Pattern'
    },
    {
     image: '../../../../assets/resources/whitepaper/behaviouraldesignpattern/Behavioural_Design_Pattern.webp',
     route:'/kalpita-white-papers/behavioural-design-patterns',
     title:' Behavioural Design Pattern'
    },
    {
     image: '../../../../assets/resources/whitepaper/eseeticketbooking/esee-ticket.webp',
     route:'/kalpita-white-papers/onlinemovie-ticket-booking',
     title:'Whitepaper on Online Movie Ticket Booking'
    },
    {
     image: '../../../../assets/resources/whitepaper/seatlayoutTicketbooking/SeatLayoutWorkflow.webp',
     route:'/kalpita-white-papers/seatlayout-workflow',
     title:'Whitepaper on Seat Layout Workflow for Movie Ticket Booking Mobile App'
    }
  ];

  constructor(private router: Router) { }

  ngOnInit(): void {
    // Get the current active URL from the Angular Router.
    const currentUrl = this.router.url;
    
    // Pass the current URL to the selection method to ensure it's excluded.
    this.selectRandomWhitepapers(currentUrl);
  }

  /**
   * Selects 3 random whitepapers, excluding the one specified by the currentRoute.
   * @param currentRoute The route of the page currently being viewed.
   */
  private selectRandomWhitepapers(currentRoute: string): void {
    // Step 1: Filter the master list to create a new list that EXCLUDES the current page.
    const availableSelections = this.allWhitepapers.filter(paper => paper.route !== currentRoute);

    // Step 2: Shuffle the filtered list of available selections.
    const shuffled = [...availableSelections].sort(() => 0.5 - Math.random());

    // Step 3: Take the first 3 items from the shuffled list.
    this.relevantWhitepapers = shuffled.slice(0, 3);
  }

  navigateTo(route: string): void {
    this.router.navigateByUrl(route);
  }
}